import { Breadcrumb } from "@/components/Breadcrumbs/Breadcrumbs";
import { BarChartOutlined } from "@ant-design/icons";
import { Outlet } from "react-router-dom";
import styles from "./Dashboard.module.scss";

export const dashboardBreadcrumbs: Breadcrumb[] = [
  {
    label: "Dashboards",
    icon: <BarChartOutlined />,
  },
];

export default function DashboardLayout() {
  return (
    <div className={styles.Dashboard}>
      <Outlet />
    </div>
  );
}
